var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"main-box"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.dataList.content)}})]),_c('div',{staticStyle:{"height":"200px"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-header"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v("组织架构")])]),_c('div',{staticClass:"address"})])
}]

export { render, staticRenderFns }